import React, { createRef, FunctionComponent, useRef, useState } from "react";
import { fetchSearch } from "../../services/questions.api";
import SuggestionContainer, { SuggestionContainerRef } from "./SuggestionContainer";
import imgSearch from '../../../../lib/images/search_black_24dp.svg';


interface SearchBarProps {
	hostApi: string;
	shopId: number;
	langId: number;
	placeholder?: string;
}

const SearchBar: FunctionComponent<SearchBarProps> = ({hostApi, shopId, langId, placeholder}) => {
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const [loading, setLoading] = useState<boolean>(false);
	const [enterInSuggest, setEnterInSuggest] = useState<boolean>(false);
	const [suggestion, setSuggestion] = useState<any[]>([]);

	const refInput = createRef<HTMLInputElement>();
	const refSuggestion = useRef<SuggestionContainerRef>();

	let faqFetchTimer: NodeJS.Timeout;

	const search = (searchValue: string): void => {
		if (searchValue !== '') {
			setSuggestion([]);
			setLoading(true);
			fetchSearch(hostApi, langId, shopId, searchValue)
				.then((response) => {
					setSuggestion(response)
					setIsOpen(true);
				})
				.finally(() => setLoading(false));
		} else {
			setSuggestion([]);
			setLoading(false);
		}
	};

	const handleKeyUp = (event: React.KeyboardEvent) => {
		const isGreaterThanZero = suggestion.length > 0;

    if (event.key === 'ArrowDown' && isGreaterThanZero) {
			refSuggestion.current?.goNext();
    } else if (event.key === 'ArrowUp' && isGreaterThanZero) {
      refSuggestion.current?.goPrevious();
    } else if (event.key === 'Enter' && isGreaterThanZero) {
      refSuggestion.current?.moveLocation();
    } else {
			clearTimeout(faqFetchTimer);
      faqFetchTimer = setTimeout(function () {
				if (refInput.current) {
					search(refInput.current.value);
				}
      }, 300);
		}
	}

	const handleClick = () => {
		if (refInput.current) {
			search(refInput.current.value);
			refInput.current.focus();
		}
	};

	return (
		<div id="search-faq-main" className={"faq-searchbar-container mb-5 " + (loading ? 'loading' : '')}>
			<input
				ref={refInput}
				id="input-faq"
				className="search-faq"
				type="text"
				placeholder={placeholder}
				autoComplete="off"
				onBlur={() => setIsOpen(false)}
				onFocus={() => setIsOpen(true)}
				onKeyUp={handleKeyUp}
			/>
			<img
				id="search-icon"
				className="search-icon"
				src={imgSearch}
				alt="search icon"
				width="30"
				draggable="false"
				onClick={handleClick}
				/>
			<div className="dots-loader" />
			<SuggestionContainer
				ref={refSuggestion}
				isOpen={enterInSuggest ? enterInSuggest : isOpen}
				items={suggestion}
        langId={langId}
				onMouseEnter={() => setEnterInSuggest(true)}
				onMouseLeave={() => setEnterInSuggest(false)}
			/>
		</div>
	);
};

export default SearchBar;
